export const SEO_CONFIG = {
  "/": {
    title: "化云闲余-闲废物资处置平台 | 高效发掘与创造闲废资产价值",
    keywords:
      "化云闲余, 闲废物资处置平台, 闲废资产价值, 废旧物资回收, 闲置物资交易",
    description:
      "化云闲余是专业的闲废物资处置平台，作为闲废资产价值的发现者和创造者，为客户提供高效合规的闲置设备处理、废旧物资回收服务，立即开启价值重塑之旅。",
  },
  "/project/list/jj": {
    title: "化云闲余-闲废物资竞价平台 | 废旧物资/二手设备/资产在线竞价交易",
    keywords: "化云闲余, 闲废物资竞价平台, 二手设备交易,资产竞价, 在线竞价",
    description:
      "化云闲余闲废物资竞价平台提供废旧物资、二手设备等各种闲废物资在线竞价交易服务，覆盖全国各省市，高效发掘闲废资产价值，立即参与竞价。",
  },
  "/project/list/pm": {
    title: "化云闲余-闲废物资拍卖平台 | 废旧物资/二手设备/资产在线拍卖交易",
    keywords: "化云闲余, 闲废物资拍卖平台, 二手设备拍卖,资产拍卖, 在线拍卖",
    description:
      "化云闲余闲废物资拍卖平台提供废旧物资、二手设备等各种闲废物资在线拍卖交易服务，覆盖全国各省市，高效发掘闲废资产价值，立即参与拍卖。",
  },
  "/project/list/jc": {
    title: "化云闲余-闲废物资进场交易平台 | 废旧物资/二手设备/资产规范交易服务",
    keywords: "化云闲余, 闲废物资进场交易平台, 二手设备交易,资产交易, 规范交易",
    description:
      "化云闲余闲废物资进场交易平台提供废旧物资、二手设备等各种闲废物资在线竞价交易服务，覆盖全国各省市，高效发掘闲废资产价值，立即进场交易。",
  },
  "/project/list/zs": {
    title: "化云闲余-闲废物资招商平台 | 废旧物资/二手设备招商项目",
    keywords:
      "化云闲余, 闲废物资招商平台, 二手设备招商,二手设备招商,闲废资产价值",
    description:
      "化云闲余闲废物资招商平台提供废旧物资、二手设等闲废物资招商项目信息，覆盖全国各省市，高效发掘闲废资产价值，立即查看招商项目。",
  },
  "/project/list/nb": {
    title: "化云闲余-闲废物资内部调配平台 | 废旧物资/二手设备内部调配项目",
    keywords:
      "化云闲余, 闲废物资内部调配平台, 二手设备招商,二手设备招商,闲废资产价值",
    description:
      "化云闲余闲废物资内部调配平台提供废旧物资、二手设等闲废物资招商项目信息，覆盖全国各省市，高效发掘闲废资产价值，立即查看内部调配项目。",
  },
  "/nbtp": {
    title: "化云闲余-闲废物资内部调配平台 | 废旧物资/二手设备内部调配项目",
    keywords:
      "化云闲余, 闲废物资内部调配平台, 二手设备招商,二手设备招商,闲废资产价值",
    description:
      "化云闲余闲废物资内部调配平台提供废旧物资、二手设等闲废物资招商项目信息，覆盖全国各省市，高效发掘闲废资产价值，立即查看内部调配项目。",
  },
  "/project/detail": {
    initTitle: "闲废物资处置平台-化云闲余",
    title: "{title}-闲废物资处置平台-化云闲余",
    keywords:
      "化云闲余, 闲废物资处置平台, 闲废资产价值, 废旧物资回收, 闲置物资交易",
    description:
      "化云闲余闲废物资处置平台提供{title}项目详情，包含挂牌价、保证金、联系电话等闲废物资处置信息，立即查看标的详情，发掘资产价值。",
  },
  "/qyzc/list": {
    title: "化云闲余-企业专场闲废物资处置平台 | 专属定制资产处置服务",
    keywords:
      "化云闲余, 企业专场闲废物资处置平台, 央国企资产处置, 民营企业资产处置, 定制化资产处置",
    description:
      "化云闲余企业专场是为大型国企、央企及民营企业打造的专属闲废物资处置平台，提供定制化资产处置服务，高效发掘闲废资产价值，立即入驻开启专场交易。",
  },
  "/qyzc/detail/qyzc": {
    initTitle:
      "企业专场-闲废物资处置平台-化云闲余 | 高效发掘与创造闲废资产价值",
    title:
      "{companyName}专场-闲废物资处置平台-化云闲余 | 高效发掘与创造闲废资产价值",
    keywords: "化云闲余, {companyName}专场, 招商项目, 竞价项目, 成交项目",
    description:
      "化云闲余{companyName}专场展示其在平台中所有招商项目、竞价项目、成交项目，可立即查看{companyName}闲废资产处置详情，快速发掘资产价值。",
  },
  "/gwczl": {
    title: "化云闲余-公务车专栏 | 二手公务车拍卖竞价交易",
    keywords: "化云闲余, 公务车专栏, 二手公务车拍卖, 二手车交易, 车辆拍卖",
    description:
      "化云闲余公务车专栏提供二手公务车拍卖竞价交易服务，涵盖各类车型，支持按项目状态、标的亮点筛选，立即查看公务车拍卖信息，参与竞价交易。",
  },
  "/news/list": {
    title: "化云闲余-资讯中心 | 闲废物资处置行业动态",
    keywords: "化云闲余资讯中心, 行业动态, 政策法规, 市场分析, 闲废资产处置",
    description:
      "化云闲余资讯中心提供闲废物资处置行业动态、政策法规、市场分析等资讯，帮助企业了解行业最新趋势，立即查看更多闲废资产处置相关资讯。",
  },
  "/news/detail/news": {
    initTitle: "化云闲余",
    title: "{title}-化云闲余",
    keywords: "{title},化云闲余, 闲废资产处置",
    description:
      "化云闲余是专业的闲废物资处置平台，作为闲废资产价值的发现者和创造者，为客户提供高效合规的闲置设备处理、废旧物资回收服务，立即开启价值重塑之旅。",
  },
  "/info/list": {
    initTitle: "化云闲余",
    title: "{navName}-化云闲余",
    keywords:
      "化云闲余, 闲废物资处置平台, 闲废资产价值, 废旧物资回收, 闲置物资交易",
    description:
      "化云闲余是专业的闲废物资处置平台，作为闲废资产价值的发现者和创造者，为客户提供高效合规的闲置设备处理、废旧物资回收服务，立即开启价值重塑之旅。",
  },
  "/info/detail": {
    initTitle: "化云闲余",
    title: "{title}-化云闲余",
    keywords:
      "化云闲余, 闲废物资处置平台, 闲废资产价值, 废旧物资回收, 闲置物资交易",
    description:
      "化云闲余是专业的闲废物资处置平台，作为闲废资产价值的发现者和创造者，为客户提供高效合规的闲置设备处理、废旧物资回收服务，立即开启价值重塑之旅。",
  },
};

/**
 * 获取当前路由的 SEO 配置
 * @param {string} path 路由路径
 * @param {Object} dynamicData 动态数据
 * @returns {Object} SEO 配置
 */
export function getSEOConfig(path, dynamicData = {}) {
  const cleanPath = path.replace(/\?.*$/, "").replace(/\/$/, "");
  let config = SEO_CONFIG[cleanPath];

  if (!config) {
    if (cleanPath.startsWith("/project/detail")) {
      config = SEO_CONFIG["/project/detail"];
    } else if (cleanPath.startsWith("/info/detail")) {
      config = SEO_CONFIG["/info/detail"];
    } else if (
      cleanPath.startsWith("/info/list") ||
      cleanPath.startsWith("/info")
    ) {
      config = SEO_CONFIG["/info/list"];
    }
  }

  config = config || SEO_CONFIG["/"];

  if (Object.keys(dynamicData).length > 0) {
    config = replaceDynamicData(config, dynamicData);
  }

  return config;
}

/**
 * 替换动态数据占位符
 */
function replaceDynamicData(config, dynamicData) {
  const result = { ...config };

  // 遍历所有属性进行占位符替换
  Object.keys(result).forEach((key) => {
    if (typeof result[key] === "string") {
      result[key] = replacePlaceholders(result[key], dynamicData);
    }
  });

  return result;
}

/**
 * 替换占位符
 */
function replacePlaceholders(text, data) {
  if (!text) return text;

  let result = text;
  result = result.replace(/\{title\}/g, data.title || "");
  result = result.replace(/\{companyName\}/g, data.companyName || "");
  result = result.replace(/\{navName\}/g, data.navName || "");

  return result;
}

/**
 * 设置页面 SEO
 * @param {Object} config SEO 配置
 */
export function setPageSEO(config, init) {
  if (!config) return;

  // 设置标题
  if (config.title) {
    document.title = init ? config.initTitle || config.title : config.title;
  }

  // 设置 meta
  setMetaTag("keywords", config.keywords);
  setMetaTag("description", config.description);
}

/**
 * 设置 meta 标签
 */
function setMetaTag(name, content) {
  if (!content) return;

  let meta = document.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }

  meta.content = content;
}
